module.exports = __webpack_public_path__ + "img/phone-icon.4715da38.png";